import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    Renderer2
} from "@angular/core";
import { timer } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AnalyticsService } from "../../../../services/analytics.service";

@Directive({
    selector: '[sliderProgress]',
})
export class SliderProgressDirective implements OnChanges {
    @Input() sliderValue: number;
    min: number = 0;
    max: number = 0;
    inputElement: HTMLInputElement;

    constructor(
        private elRef: ElementRef,
        private renderer: Renderer2,
    ) {
        this.inputElement = this.elRef.nativeElement;
        this.changeColor();
    }

    ngOnChanges(): void {
        this.changeColor();
    }

    changeColor() {
        const inputValue = this.inputElement.valueAsNumber;
        this.min = +this.inputElement.min;
        this.max = +this.inputElement.max;
        this.renderer.removeClass(this.inputElement, 'is-large');
        this.renderer.removeClass(this.inputElement, 'is-circle');
        this.renderer.removeClass(this.inputElement, 'is-fullwidth');
        this.renderer.removeClass(this.inputElement, 'slider');
        this.renderer.addClass(this.inputElement, 'slider-with-progress');
        const calculatedValue = (this.max) ? ((inputValue - this.min) / (this.max - this.min) * 100) : inputValue;
        const background = `linear-gradient(to right, #809fff 0% ${calculatedValue}%, #dbdbdb ${calculatedValue}% 100%)`;
        this.renderer.setStyle(this.inputElement, 'background', background);
    }
}